import { BaseQueryWithValidationClass } from 'src/editor/api/queries/utils/query-with-validation-class'
import { fetchUserData, UserData } from 'src/editor/api/user-data-api'

class UserDataQueryClass extends BaseQueryWithValidationClass<[], UserData> {
  queryFn = () => fetchUserData()
  getQueryKey = () => ['userData'] as const
}

export const userDataQuery = new UserDataQueryClass()
